/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const BuySellTradeSm = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 28 24" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M21.75 7a2.17 2.17 0 0 0-1.09-.43h-.18V5.05a2 2 0 0 1 .46.12 2 2 0 0 1 .41.27l.07.06.68-.68-.1-.06a2.88 2.88 0 0 0-.72-.48 2.87 2.87 0 0 0-.76-.17v-.43h-.83v.45a3 3 0 0 0-.63.17 1.6 1.6 0 0 0-1 1.54 1.52 1.52 0 0 0 .42 1.1 1.8 1.8 0 0 0 1.14.5h.11V9a2.35 2.35 0 0 1-.62-.15 2.2 2.2 0 0 1-.51-.36l-.07-.06-.7.7.08.07a2.69 2.69 0 0 0 .83.56 3.09 3.09 0 0 0 .92.19v.58h.83v-.6a2.54 2.54 0 0 0 .79-.22 1.57 1.57 0 0 0 .92-1.48A1.52 1.52 0 0 0 21.75 7zm-2-.55a1 1 0 0 1-.47-.21.58.58 0 0 1-.18-.45.7.7 0 0 1 .65-.74zM21 8.77a1.3 1.3 0 0 1-.53.22V7.54a1.25 1.25 0 0 1 .53.2.57.57 0 0 1 .2.51.61.61 0 0 1-.2.52z" /><path d="M14.45 7.11a5.62 5.62 0 1 1 7 5.43l1 1c.19 0 .37.06.55.09a7.13 7.13 0 1 0-9.61-4.14H15a5.61 5.61 0 0 1-.55-2.38z" /><path d="M26.84 17.32a5.69 5.69 0 0 0-5-2.59l-3.8-3.8a.75.75 0 0 0-.53-.22h-5.26V9.66l-3.1 1.8 3.1 1.79v-1h5L21 16a.75.75 0 0 0 .53.22 4.53 4.53 0 0 1 3.88 1.67v1.92h-2.54a3.07 3.07 0 1 0 0 1.5h3.31a.75.75 0 0 0 .75-.75v-2.89a.73.73 0 0 0-.09-.35zm-6.93 4.81a1.57 1.57 0 1 1 1.57-1.57 1.56 1.56 0 0 1-1.57 1.57z" /><path d="M15.78 20.56l-3.11-1.79v1h-2.62a3.05 3.05 0 0 0-5.92 0H1.5v-2.44a1 1 0 0 1 1-1.09h2.3a.78.78 0 0 0 .46-.16l3.81-3-1.34-.86-3.19 2.52h-2a2.7 2.7 0 0 0-1.81.72A2.52 2.52 0 0 0 0 17.33v3.23a.75.75 0 0 0 .75.75h3.38a3 3 0 0 0 5.92 0h2.62v1.05zm-8.69 1.57a1.57 1.57 0 1 1 1.57-1.57 1.56 1.56 0 0 1-1.57 1.57z" />
      </g>
    </svg>
  </span>
);

BuySellTradeSm.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

BuySellTradeSm.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default BuySellTradeSm;
